<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-text-field v-model="queryForm.driver_name" label="司机姓名" outlined dense hide-details
          @keyup.enter="getdata()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <div class="d-flex align-center pl-2">
        <span>共 {{ length }} 页 / {{ count }} 条数据</span>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
              {{ limit }}/页
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in pages" :key="index" @click="limit = item.value">
              <v-list-item-title>{{ item.value }}/页</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <span class="ml-3 grey--text text--darken-1" v-if="queryForm.start_day && queryForm.end_day">
          统计区间：{{ queryForm.start_day }} 08:00 ~ {{ queryForm.end_day }} 08:00
        </span> -->
      </div>
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="index" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="driver_name" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="driver_mobile" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="mileage" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="km" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="km0" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="on_time" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="off_time" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="duration" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "DriverPerformance",
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      queryForm: {
        start_day: "",
        end_day: "",
        driver_name: "",
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: '序号', dataIndex: 'index', scopedSlots: { customRender: 'index' }, width: 80, align: 'center' },
        { title: '司机姓名', dataIndex: 'driver_name', scopedSlots: { customRender: 'driver_name' }, width: 120, align: 'center' },
        { title: '手机号', dataIndex: 'driver_mobile', scopedSlots: { customRender: 'driver_mobile' }, width: 120, align: 'center' },
        { title: 'GPS里程', dataIndex: 'mileage', scopedSlots: { customRender: 'mileage' }, width: 100, align: 'center' },
        { title: '标准里程', dataIndex: 'km', scopedSlots: { customRender: 'km' }, width: 100, align: 'center' },
        { title: '空返里程', dataIndex: 'km0', scopedSlots: { customRender: 'km0' }, width: 100, align: 'center' },
        { title: '上车时间', dataIndex: 'on_time', scopedSlots: { customRender: 'on_time' }, width: 160, align: 'center' },
        { title: '下车时间', dataIndex: 'off_time', scopedSlots: { customRender: 'off_time' }, width: 160, align: 'center' },
        { title: '时长', dataIndex: 'duration', scopedSlots: { customRender: 'duration' }, width: 120, align: 'center' },
      ],
      limit: 20,
      length: 0,
      count: 0,
      list: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 200), 0);
    },
    summaryList() {
      if (!this.list || this.list.length === 0) {
        return [];
      }
      const sum = (key) => this.list.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
      return [
        {
          _id: 'summary',
          _isSummary: true,
          index: '合计',
          mileage: Math.round(sum('mileage') * 100) / 100,
          km: Math.round(sum('km') * 100) / 100,
          // 时长单位为分钟，直接取整
          duration: Math.round(sum('duration')),
        },
        ...this.list
      ];
    },
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = () => {
      this.height = window.innerHeight - 300;
    };
    this.queryForm = {
      start_day: this.$moment().subtract(1, 'day').format('YYYY-MM-DD'),
      end_day: this.$moment().format('YYYY-MM-DD'),
      driver_name: '',
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/driverperformance/list", {
        page: this.page,
        limit: this.limit,
        ...this.queryForm,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
}
</style>
